import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
    IFormFieldDimensionDefaultValueKey,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    allGlasses,
    allMarbleAndStones,
    allMetals,
    allMelamine,
    allPlastics,
    getMaterialsWithExceptions,
    allWoods,
    allRecycledWoods,
} from './common/materialGroups';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const shelfForm: IForm = {
    formId       : PublishedFormId.Shelf,
    type         : FormTypeId.GlassAndMirror,
    thumbnailURL : '/resized-images/forms/shelf.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.Material,
        IFormFieldKey.Dimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allWoods,
                        ...allGlasses,
                        ...allMetals,
                        ...allMarbleAndStones,
                        ...allMelamine,
                        ...allPlastics,
                    ],
                    [
                        ...allRecycledWoods,
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.DouglasEngineered,
                        MaterialId.DouglasVeneer,
                        MaterialId.Redcedar,
                        MaterialId.RedcedarEngineered,
                        MaterialId.RedcedarVeneer,
                        MaterialId.Larch,
                        MaterialId.LarchEngineered,
                        MaterialId.LarchVeneer,
                        MaterialId.Padouk,
                        MaterialId.PadoukEngineered,
                        MaterialId.PadoukVeneer,
                        MaterialId.Ipe,
                        MaterialId.IpeEngineered,
                        MaterialId.IpeVeneer,
                        MaterialId.Garapa,
                        MaterialId.SheetMetal,
                        MaterialId.PlexiglassFluorescent,
                        MaterialId.PlexiglassFrosted,
                        MaterialId.PlexiglassMirror,
                        MaterialId.PlexiglassTransparent,
                        MaterialId.PlexiglassWhite,
                        MaterialId.PolycarbonateOpaque,
                        MaterialId.PolycarbonateTeinted,
                        MaterialId.PolycarbonateTransparent,
                        MaterialId.Pvc,
                        MaterialId.PvcRigid,
                    ],
                ),
                required: true,
            },
        },
        dimension: {
            [FieldDimensionId.Length]: {
                value         : undefined,
                type          : IFormInputType.Range,
                unit          : IDimensionUnit.Centimeters,
                step          : 10,
                range         : { min: 200, max: 2000 },
                required      : true,
                defaultValue  : 1000,
                defaultValues : [
                    [IFormFieldDimensionDefaultValueKey.StandardLength, 1000],
                ],
            },
            [FieldDimensionId.Width]: {
                value         : undefined,
                type          : IFormInputType.Range,
                unit          : IDimensionUnit.Centimeters,
                step          : 10,
                range         : { min: 100, max: 500 },
                required      : true,
                defaultValue  : 200,
                defaultValues : [
                    [IFormFieldDimensionDefaultValueKey.StandardWidth, 200],
                ],
            },
            [FieldDimensionId.Thickness]: {
                value         : undefined,
                type          : IFormInputType.Range,
                unit          : IDimensionUnit.Centimeters,
                step          : 10,
                range         : { min: 10, max: 100 },
                required      : true,
                defaultValue  : 20,
                defaultValues : [
                    [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
                ],
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 10000,
            budgetDefaultValue : 2000,
            marks              : budgetMarksBuilder(500, 100, 5000, 250, 10000),
        }),
        contact: fieldsContact,
    },
};

export default shelfForm;
